import { Button, Separator } from '@treasuryspring/spring-ui';

import { useRatesQuery } from '@/api/query';
import atlarLogoSrc from '@/assets/atlar.svg';
import bracketLogoSrc from '@/assets/bracket.svg';
import cwanLogoSrc from '@/assets/cwan.svg';
import firstminuteLogoSrc from '@/assets/firstminute.png';
import hazeltreeLogoSrc from '@/assets/hazeltree.png';
import kyribaLogoSrc from '@/assets/kyriba.svg';
import logo from '@/assets/logo.svg';
import marexLogoSrc from '@/assets/marex.svg';
import ocorianLogoSrc from '@/assets/ocorian.png';
import tradewebLogoSrc from '@/assets/tradeweb.png';
import icon from '@/assets/ts-favicon.svg';

const logos: Record<string, string> = {
  tradeweb: tradewebLogoSrc,
  hazeltree: hazeltreeLogoSrc,
  cwan: cwanLogoSrc,
  atlar: atlarLogoSrc,
  kyriba: kyribaLogoSrc,
  firstminute: firstminuteLogoSrc,
  ocorian: ocorianLogoSrc,
  bracket: bracketLogoSrc,
  marex: marexLogoSrc,
};
const brandings = Object.keys(logos);

export default function Banner() {
  const { branding } = useRatesQuery().data || {
    branding: 'none',
  };
  const brandingLower = branding.toLowerCase();
  const hasBranding = brandings.includes(brandingLower);
  return (
    <div className="py-s px-l bg-surface fixed top-0 z-10 box-border w-screen overflow-auto border-b">
      <div className="gap-x-xl gap-y-m w-page-break m-auto box-border flex max-w-full flex-wrap items-center justify-between">
        <div className="gap-m flex items-center">
          {!hasBranding ? (
            <>
              <img
                src={logo}
                alt="TreasurySpring"
                className="h-xl hidden sm:block"
              />
              <img src={icon} alt="TS" className="h-l sm:hidden" />
            </>
          ) : (
            <>
              <img
                src={logos[brandingLower]}
                alt={brandingLower === 'cwan' ? 'Clearwater' : branding}
                className="h-l"
              />
              <Separator orientation="vertical" className="h-10 w-px" />
              <div className="gap-xxs flex flex-col items-start">
                <p className="text-description text-body-sm whitespace-nowrap">
                  In partnership with
                </p>
                <img src={logo} alt="TreasurySpring" className="h-l" />
              </div>
            </>
          )}
        </div>
        <div className="gap-s flex items-center">
          <a
            href="https://app.treasuryspring.com"
            target="_blank"
            rel="noreferrer"
          >
            <Button size="small">Platform login</Button>
          </a>
          <a
            href="https://treasuryspring.com/contact"
            target="_blank"
            rel="noreferrer"
          >
            <Button size="small">Sign up</Button>
          </a>
        </div>
      </div>
    </div>
  );
}
